let staticData = new Object ({

    dataTableFooterOptions : {
      showFirstLastPage: true,
      'items-per-page-options': [5 , 10 , 20, 50, 100],
    },

    defautPerPage : 10,

});

export default staticData;
